import React, { Fragment, useCallback, useMemo } from 'react';
import T from 'prop-types';
import { includes, toString } from 'lodash-es';

import PopularApps from './PopularApps';
import SearchTypeahead from '../../../../../components/SearchTypeahead';
import useMobileView from '../..//shared/hooks/useMobileView';

const filterSearchResults = (results) => results.filter((app) => app.dls_30d !== 0);

const FindAppModalContent = ({ selectedApps, popularApps, onHide, onChange }) => {
  const isMobileView = useMobileView();
  const popularAppsChunk = useMemo(() => popularApps.slice(0, 8), [popularApps]);
  const selectedAppsIds = useMemo(
    () => selectedApps.map(({ ref_no }) => toString(ref_no)),
    [selectedApps]
  );

  // Search
  const handleChange = useCallback(([app]) => {
    onChange((prevApps) => {
      if (!prevApps.some(({ ref_no }) => `${ref_no}` === `${app.ref_no}`)) {
        return [...prevApps, app];
      }
      return prevApps;
    });
    onHide(false);
  }, []);

  const handleItemSelected = useCallback(
    (app) => ({
      itemSelected: includes(selectedAppsIds, `${app.ref_no}`),
    }),
    [selectedAppsIds]
  );

  return (
    <Fragment>
      <div className="find-app-modal__search">
        <SearchTypeahead
          onChange={handleChange}
          itemSelected={handleItemSelected}
          decorateItems={filterSearchResults}
          searchAsset="apps"
          maxHeight={isMobileView ? '208px' : '266px'}
          autoFocus
          placeholder="Search for an app"
          decorators={['dls_30d', 'big_icon_url']}
          minLength={1}
          disableSearchOnFocus
          disableRecentResults
          includesUnified
        />
      </div>
      <PopularApps
        apps={popularAppsChunk}
        title="Popular Apps"
        appSize={48}
        className="find-app-modal__popular-apps"
        onAppSelect={handleChange}
      />
    </Fragment>
  );
};

FindAppModalContent.propTypes = {
  selectedApps: T.array.isRequired,
  popularApps: T.array.isRequired,
  onHide: T.func.isRequired,
  onChange: T.func.isRequired,
};

export default FindAppModalContent;
